module.exports = __webpack_public_path__ + "static/media/cassandra_fun.39e99259.png";